import { Loader } from 'components';
import React, { useState, useRef, useEffect } from 'react';

// Show VPN message if initial loading is taking a while
export function LoaderVPN({ loadPromise }: { loadPromise: Promise<any> | undefined }) {
    const [loadIsSlow, setLoadIsSlow] = useState(false);
    const isFirstLoadRef = useRef(true);
    useEffect(() => {
        if (isFirstLoadRef.current && loadPromise) {
            isFirstLoadRef.current = false;

            // Show the message after 5 seconds
            const slowTimeoutId = setTimeout(() => {
                setLoadIsSlow(true);
            }, 5000);
            const cancelSlowTimeout = () => {
                clearTimeout(slowTimeoutId);
            }

            // Cancel the timeout if the promise finishes, or if we unmount.
            loadPromise.finally(cancelSlowTimeout);
            return cancelSlowTimeout;
        }
    }, [loadPromise]);

    return <>
        <Loader />
        {loadIsSlow && (
            <div className="loadingSlowMessage">
                Loading appears slow. Please ensure you're on VPN and contact the SmartEquip team if issues persist.
            </div>
        )}
    </>
}